<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      :outputConfigurations="outputConfigurations"
      simulationLabel="TuxhornEThermP9Plus_1d03_P50"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import TuxhornEThermP9Plus_1d03_P50 from '@/device-products/TuxhornEThermP9Plus_1d03_P50.vue';
import PVSensormodul from '@/device-products/PVSensormodul.vue';
import DdsSensor from '@/device-products/DdsSensor.vue';
import ResolEM from '@/device-products/ResolEM.vue';
import OnionRpc from '@/device-products/OnionRpc.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
          {
            id: 'Regler zu Modul 1',
            from: { deviceId: 0, uart: 0},
            to: { deviceId: 4, uart: 0},
          }, {
            id: 'Modul 1 zu Modul 2',
            from: { deviceId: 4, uart: 0},
            to: { deviceId: 5, uart: 0},
          }, {
            id: 'Modul 2 zu Modul 3',
            from: { deviceId: 5, uart: 0},
            to: { deviceId: 6, uart: 0},
          }, {
            id: 'Modul 3 zu Modul 4',
            from: { deviceId: 6, uart: 0},
            to: { deviceId: 7, uart: 0},
          }, {
            id: 'Modul 4 zu Modul 5',
            from: { deviceId: 7, uart: 0},
            to: { deviceId: 8, uart: 0},
          }
        ],
      },
      {
        label: 'Intern', connections: [
          {
            id: 'Regler zu PVS',
            from: { deviceId: 0, uart: 1},
            to: { deviceId: 1, uart: 0},
          }
        ],
      },
      {
        label: 'DDS', connections: [
          {
            id: 'Regler zu DDS 1',
            from: { deviceId: 0, uart: 2},
            to: { deviceId: 2, uart: 0},
          },
          {
            id: 'Regler zu DDS 2',
            from: { deviceId: 0, uart: 2},
            to: { deviceId: 3, uart: 0},
          }
        ],
      },
      {
        label: 'Omega', connections: [
          {
            id: 'Regler zu Onion',
            from: { deviceId: 0, uart: 3},
            to: { deviceId: 9, uart: 0},
            suppressEcho: true
          }
        ]
      },
    ],
    outputConfigurations: [{
      label: 'PV-Max an PVS',
      connections: [{
        id: 'R1',
        from: { deviceId: 0, index: 0 },
        to: { deviceId: 1, index: 0 },
      }, {
        id: 'R2',
        from: { deviceId: 0, index: 1 },
        to: { deviceId: 1, index: 1 },
      }, {
        id: 'R3',
        from: { deviceId: 0, index: 2 },
        to: { deviceId: 1, index: 2 },
      }, {
        id: 'R4',
        from: { deviceId: 0, index: 3 },
        to: { deviceId: 1, index: 3 },
      }, {
        id: 'R5',
        from: { deviceId: 0, index: 4 },
        to: { deviceId: 1, index: 4 },
      }, {
        id: 'A1',
        from: { deviceId: 0, index: 5 },
        to: { deviceId: 1, index: 5 },
      }, {
        id: 'A2',
        from: { deviceId: 0, index: 6 },
        to: { deviceId: 1, index: 6 },
      }],
    }, {
      label: 'PV-Max an Onion',
      connections: [{
        id: 'Omega_GPIO15' /* EventQueue */,
        from: { deviceId: 0, configId: 0x36740c2c, index: 15 },
        to: { deviceId: 9, index: 0, outputType: 2 /*digital */ }
      }, {
        id: 'Omega_GPIO16' /* BootupPin */,
        from: { deviceId: 9, index: 1},
        to: { deviceId: 0, configId: 0x36740c2c, index: 16 },
      }, {
        id: 'R1',
        from: { deviceId: 0, index: 0 },
        to: { deviceId: 9, index: 2 },
      }, {
        id: 'R2',
        from: { deviceId: 0, index: 1 },
        to: { deviceId: 9, index: 3 },
      }, {
        id: 'R3',
        from: { deviceId: 0, index: 2 },
        to: { deviceId: 9, index: 4 },
      }, {
        id: 'R4',
        from: { deviceId: 0, index: 3 },
        to: { deviceId: 9, index: 5 },
      }, {
        id: 'R5',
        from: { deviceId: 0, index: 4 },
        to: { deviceId: 9, index: 6 },
      }, {
        id: 'A1',
        from: { deviceId: 0, index: 5 },
        to: { deviceId: 9, index: 7 },
      }, {
        id: 'A2',
        from: { deviceId: 0, index: 6 },
        to: { deviceId: 9, index: 8 },
      }],
    }],
    simulationDevices: [
      { id: 0, component: TuxhornEThermP9Plus_1d03_P50, deviceLabel: "Tuxhorn eTherm P9+ 1.03-P50" },
      { id: 9, component: OnionRpc, deviceLabel: 'Onion Omega', deviceColor: '#F4a336', props: {
        onionBootupTime: 10000,
        // onionBootupTime: 30000, // 30s
        controllerOutputs: [
          { name: 'R1', index: 2, },
          { name: 'R2', index: 3, },
          { name: 'R3', index: 4, },
          { name: 'R4', index: 5, },
          { name: 'R5', index: 6, },
          { name: 'A1', index: 7, },
          { name: 'A2', index: 8, },
        ],
      }},
      { id: 1, component: PVSensormodul, deviceLabel: "PVS", deviceColor: 'lime lighten-4', props: {
        vbusAddress: 0x1116,
        controllerOutputs: [
          { name: 'R1', index: 0, },
          { name: 'R2', index: 1, },
          { name: 'R3', index: 2, },
          { name: 'R4', index: 3, },
          { name: 'R5', index: 4, },
          { name: 'A1', index: 5, },
          { name: 'A2', index: 6, },
        ],
        defaultValues: {
          maximumValue: 20000,
          minimumValue: -3000,
        },
      }},
      { id: 2, component: DdsSensor, deviceLabel: 'DDS 1', deviceColor: 'green', props: {
        defaultSensorType: 'VFD1_12',
        defaultValues: [
          { conversion: 'rawTemperature', value: 22.0 },
          { conversion: 'rawFlow', value: 2.0 },
        ],
      }},
      { id: 3, component: DdsSensor, deviceLabel: 'DDS 2', deviceColor: 'green darken-2', props: {
        defaultSensorType: 'VFD2_40F',
        defaultValues: [
          { conversion: 'rawTemperature', value: 24.0 },
          { conversion: 'rawFlow', value: 4.0 },
        ],
      }},
      { id: 4, component: ResolEM, deviceLabel: 'EM 1', deviceColor: 'blue lighten-4', props: {
        vbusAddress: 0x6651,
      }},
      { id: 5, component: ResolEM, deviceLabel: 'EM 2', deviceColor: 'blue lighten-2', props: {
        vbusAddress: 0x6652,
      }},
      { id: 6, component: ResolEM, deviceLabel: 'EM 3', deviceColor: 'blue', props: {
        vbusAddress: 0x6653,
      }},
      { id: 7, component: ResolEM, deviceLabel: 'EM 4', deviceColor: 'blue darken-2', props: {
        vbusAddress: 0x6654,
      }},
      { id: 8, component: ResolEM, deviceLabel: 'EM 5', deviceColor: 'blue darken-4', props: {
        vbusAddress: 0x6655,
      }},
    ],
  }),
};
</script>

<style>

</style>
